import React from 'react';
import { useSeoDefaults } from '@funtech-int/yango-shared';

import { IMG_ALLPLAY_FAVICON_YASTATIC } from '@kinopoisk-int/common-static';

export const FaviconLinks = () => {
    const { Head } = useSeoDefaults();

    return (
        <Head>
            <link
                rel="icon"
                href={IMG_ALLPLAY_FAVICON_YASTATIC.faviconIco}
                sizes="16x16 32x32 48x48"
                type="image/x-icon"
            />
            <link
                rel="icon"
                href={IMG_ALLPLAY_FAVICON_YASTATIC.faviconSvg}
                sizes="any"
                type="image/svg+xml"
            />
            <link rel="apple-touch-icon" href={IMG_ALLPLAY_FAVICON_YASTATIC.appleTouchIcon} />
            <link
                rel="apple-touch-icon"
                sizes="152x152"
                href={IMG_ALLPLAY_FAVICON_YASTATIC.appleTouchIcon152}
            />
            <link
                rel="apple-touch-icon"
                sizes="167x167"
                href={IMG_ALLPLAY_FAVICON_YASTATIC.appleTouchIcon167}
            />
            <link
                rel="apple-touch-icon"
                sizes="180x180"
                href={IMG_ALLPLAY_FAVICON_YASTATIC.appleTouchIcon180}
            />
        </Head>
    );
};
